import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDqGMFvyBwv8CuCKEhcirZ14DXJqK0mToE",
  authDomain: "jobster-8f673.firebaseapp.com",
  projectId: "jobster-8f673",
  storageBucket: "jobster-8f673.appspot.com",
  messagingSenderId: "134364118641",
  appId: "1:134364118641:web:0ee2ff950594aa0c9225d0",
  measurementId: "G-0JGEEWY3HS",
};
let messaging;
if (firebase.messaging.isSupported()) {
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  messaging = firebase.messaging();
} else {
  console.log("no-support :(");
}

export { messaging };
export default firebase;
